import { cn } from '@/utils';

function ErrorMessage({ children, className, ...props }) {
	return (
		<p
			className={cn(
				'mt-[5px] text-xs font-semibold leading-[20px] text-red',
				className
			)}
			{...props}
		>
			{children}
		</p>
	);
}

export default ErrorMessage;
